import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import withAuthentication from '@hocs/withAuthentication';
import OrderedProductsReview from '@screens/OrderedProductsReview';
import { LayoutContext } from '@context/LayoutContext';
import { useContext } from 'react';
import { useTranslations } from 'next-intl';
import { injectLayoutData } from '@utils/layout';
import { GetStaticProps } from 'next';

const {
  publicRuntimeConfig: { appBaseUrl },
} = getConfig();

const PageOrderedProductsReview: React.FC = () => {
  const router = useRouter();
  const { setCustomTitleHeaderMobile } = useContext(LayoutContext);

  const tAccount = useTranslations('Account');

  setCustomTitleHeaderMobile!(tAccount('myProductsToReview'));

  return (
    <>
      <NextSeo
        title={tAccount('productsToReview')}
        canonical={`${appBaseUrl}${router.pathname}`}
        openGraph={{
          url: `${appBaseUrl}${router.pathname}`,
          title: tAccount('productsToReview'),
        }}
      />
      <OrderedProductsReview />
    </>
  );
};

export const getStaticProps = injectLayoutData<any, GetStaticProps>(
  async () => ({
    props: {},
    revalidate: 1800, // 30min
  }),
);

export default withAuthentication(PageOrderedProductsReview);
